if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this._prefix = window.KT_PREFIX || '';

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll(`.${this._prefix}announcement`);
      this.nextButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--right`);
      this.prevButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--left`);

      this.index = 0;
      this.length = this.content.length;

      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayIntervalDelay = this.dataset.autoplayInterval
        ? parseInt(this.dataset.autoplayInterval, 10)
        : 5000;

      this._autoplayInterval = null;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('next');
        });
      }

      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('prev');
        });
      }

      /* Mobile-only rotation: the multi-slide rotating bar is a mobile UX
         decision. On desktop the CSS hides slides 2..N and the nav chevrons,
         so we must also keep the autoplay timer from running there — otherwise
         the slider would still scroll between hidden slides and the visible
         (first) slide would mysteriously disappear when it rotated past.

         Use matchMedia + a `change` listener so we react to viewport size
         flips (orientation change / resizing the browser window) at runtime,
         not just on initial load. */
      this._mql = (typeof window.matchMedia === 'function')
        ? window.matchMedia('(max-width: 767px)')
        : null;

      const syncAutoplay = () => {
        const isMobile = this._mql ? this._mql.matches : true;
        if ( this.autoplayEnabled && this.length > 1 && isMobile ) {
          this.startAutoplay();
        } else {
          this.stopAutoplay();
          /* Reset to the first slide so the countdown is what's visible
             when rotation is turned off (e.g. resizing to desktop). */
          this.index = 0;
          if ( this.slider && this.content[0] ) {
            try {
              this.slider.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            } catch (_) { /* ignore IE-style scrollTo signatures */ }
          }
        }
      };

      if ( this._mql ) {
        /* `change` covers modern browsers; `addListener` is the deprecated
           Safari < 14 fallback. Both are no-ops on each other so we register
           defensively without sniffing. */
        if (typeof this._mql.addEventListener === 'function') {
          this._mql.addEventListener('change', syncAutoplay);
        } else if (typeof this._mql.addListener === 'function') {
          this._mql.addListener(syncAutoplay);
        }
      }
      syncAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();

      const tick = () => {
        if ( this.index < this.length - 1 ) {
          this.changeSlide('next');
        } else {
          // loop from last → first
          this.index = -1;
          this.changeSlide('next');
        }
      };

      this._autoplayInterval = setInterval(tick, this.autoplayIntervalDelay);
    }

    stopAutoplay() {
      if ( this._autoplayInterval ) {
        clearInterval(this._autoplayInterval);
        this._autoplayInterval = null;
      }
    }

    changeSlide(direction) {
      if (!this.slider || !this.length) return;

      this.nextButton?.classList.remove(`${this._prefix}announcement-bar__content-nav--disabled`);
      this.prevButton?.classList.remove(`${this._prefix}announcement-bar__content-nav--disabled`);

      if ( direction === 'next' ) {
        this.index++;
      } else if ( direction === 'prev' ) {
        this.index--;
      }

      if ( this.index < 0 ) this.index = 0;
      if ( this.index > this.length - 1 ) this.index = this.length - 1;

      if ( this.index === this.length - 1 ) {
        this.nextButton?.classList.add(`${this._prefix}announcement-bar__content-nav--disabled`);
      }
      if ( this.index === 0 ) {
        this.prevButton?.classList.add(`${this._prefix}announcement-bar__content-nav--disabled`);
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}